<template>
  <div>
    <div class="container px-6 mt-16">
      <h1 class="text-lg pl-0 md:pl-6 font-bold"><span class="text-pink-500">3.</span>
        {{ $t('messages.steps.spiritual_qualities') }}
      </h1>
      <div class="w-full ">
        <div
          v-for="(item, index) in filtered_question"
          :key="index"
        >
          <div
            class="flex mt-6 flex-wrap"
            v-for="(data, id) in item.subcategories"
            :key="id"
          >
            <h1
              v-if="data.key === 'general-spiritual-qualities'"
              class=" w-full uppercase text-lg text-blue-500 font-bold mt-6 pl-6"
            ></h1>
            <h1 v-else>{{data.name[locale]}}</h1>

            <template v-for="(question) in data.questions">
              <question
                :question="question.title"
                :typeQuestion="question.type_question"
                :placeholder="question.placeholder"
                :questionOption="question.options"
                :vvScope="vvScope"
                :validations="{ required: question.required === 1}"
                :block="question.validate_text"
                :name="question.title"
                :width="question.width"
                :key="question.id"
                :id="question.id"
              >
              </question>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Question from "@/components/Question.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
export default {
  name: "RegisterStepThree",
  components: {
    Question
  },
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  data() {
    return {
      vvScope: "step3",
      filtered_question: [],
      form: {
        goals: ""
      }
    };
  },
  computed: {
    ...mapState("questions", ["questions"]),
    ...mapState("locale", ["locale"])
  },
  async created() {
    await this.getQuestions();
    await this.showQuestion();
  },
  methods: {
    ...mapActions("questions", ["getQuestions"]),

    showQuestion() {
      this.filtered_question = this.questions.filter(
        question => question.key === "spiritual-qualities"
      );
    },
    changeAnswer() {
      this.saveAnswers({
        id: this.id,
        field: this.field,
        type: this.typeQuestion.name
      });
    }
  }
};
</script>
